export default __webpack_public_path__ + "static/media/property_906.95ee29cf.png";